// removed by extract-text-webpack-plugin
module.exports = {"button":"_3UACzDwd21tXkGeA-N5Izw"};


/*****************
 ** WEBPACK FOOTER
 ** ../app/Components/Survey/BackButton/styles.scss
 ** module id = 425
 ** module chunks = 0
 **/